export default "__VITE_ASSET__Dwu5jk1e__"